<template>
    <div>
        <div class="intro">
            <h2>{{$t('user.settings.tab.p11.header')}}</h2>
        </div>
        <div class="settings-content">
            <loader class="settings-loader" v-if="loading"></loader>
            <div v-else>
                <div class="row">
                    <div class="info">
                        <p class="label">{{$t('user.settings.tab.p11.checkbox.label')}}</p>
                        <p>{{$t('user.settings.tab.p11.checkbox.description')}}</p>
                    </div>
                    <div class="edit">
                        <label class="switch">
                            <input
                                    type="checkbox"
                                    @click="custom_special_conditions_enabled = !custom_special_conditions_enabled"
                                    v-model="custom_special_conditions_enabled"
                            />
                            <div class="slider"></div>
                        </label>
                    </div>
                </div>
                <div class="row w-100">
                    <div class="info">
                        <p class="label">{{$t('user.settings.tab.p11.textarea.label')}}</p>
                        <p>{{$t('user.settings.tab.p11.textarea.description')}}</p>
                    </div>
                    <div class="textarea input-container">
                        <textarea
                                :disabled="!custom_special_conditions_enabled"
                                v-model="custom_special_conditions_text">
                        </textarea>
                    </div>
                    <div class="save-button-container">
                        <button class="button purple float-right" @click="submit">{{$t('user.settings.label.save')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Loader from "../Loader";
    import {mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters([
                'getToken',
            ])
        },
        components: {
            Loader,
        },
        data() {
            return {
                loading: true,
                custom_special_conditions_enabled: false,
                custom_special_conditions_text: ''
            }
        },
        methods: {
            submit: function () {
                axios({
                    method: 'POST',

                    url: window.config.apiUrl + 'api/user/settings',
                    data: {
                        custom_special_conditions_enabled : this.custom_special_conditions_enabled,
                        custom_special_conditions_text : this.custom_special_conditions_text
                    }
                }).then(response => {
                    this.$store.commit('setSuccessBarMessage', this.$t('user.settings.tab.p11.success'));
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        mounted: function () {
            axios({
                method: 'GET',

                url: window.config.apiUrl + 'api/user/settings'
            }).then(response => {
                this.custom_special_conditions_enabled = Boolean(response.data.custom_special_conditions_enabled);
                this.custom_special_conditions_text = response.data.custom_special_conditions_text;
            }).finally(() => {
                this.loading = false;
            });
        },

        name: "SpecialConditions"
    }
</script>

<style lang="scss">
    .settings-loader {
        height: 50vh
    }

    .w-100 {
        flex-wrap: wrap;

        .textarea {
            width: 100%;

            textarea {
                width: calc(100% - 40px);
                height: 25vh;
                margin-top: 30px;
                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
                min-height: 120px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.16);
                padding: 20px;
                font-size: 16px;
            }
        }

        .save-button-container {
            margin-top: 30px;
            margin-left: auto;
        }
    }


</style>
